import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=a17da80a&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"
import style0 from "./Modal.vue?vue&type=style&index=0&id=a17da80a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a17da80a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a17da80a')) {
      api.createRecord('a17da80a', component.options)
    } else {
      api.reload('a17da80a', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=a17da80a&scoped=true", function () {
      api.rerender('a17da80a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/staffDirectory/Modal.vue"
export default component.exports